// Only load English synchronously for initial render (performance optimization)
import en from './English.json';

// Export only English in the bundle - other languages loaded on demand
export const languages = { en };

// Supported language codes
export const supportedLanguages = ['en', 'es', 'pt', 'de', 'fr', 'no', 'se', 'it', 'fi', 'nl', 'ro', 'pl', 'dk'];

// Dynamic language loader - loads language files on demand to reduce initial bundle size
export const loadLanguage = async (lang) => {
  if (lang === 'en') return en;

  const langMap = {
    es: () => import('./Spanish.json'),
    pt: () => import('./Portuguese.json'),
    de: () => import('./German.json'),
    fr: () => import('./French.json'),
    no: () => import('./Norwegian.json'),
    se: () => import('./Swedish.json'),
    it: () => import('./Italian.json'),
    fi: () => import('./Finnish.json'),
    nl: () => import('./Dutch.json'),
    ro: () => import('./Romanian.json'),
    pl: () => import('./Polish.json'),
    dk: () => import('./Danish.json')
  };

  if (langMap[lang]) {
    const module = await langMap[lang]();
    return module.default;
  }
  return null;
};
